interface BundleSpecialIds {
  discount?: number[] | null;
  qualify?: number[] | null;
}

interface ProductWithSpecialIds {
  applicable_bundle_special_ids?: BundleSpecialIds | null;
  applicable_special_ids?: number[] | null;
}

// Specific to the custom special label on the product card
// When product specials are present, return only those.
// Otherwise, return other specials.
export const getSpecialIdsForTagLabel = (
  product: ProductWithSpecialIds | null | undefined
): number[] => {
  const productSpecialIds = product?.applicable_special_ids ?? [];

  if (productSpecialIds.length > 0) {
    return productSpecialIds;
  }

  return [
    ...new Set([
      ...(product?.applicable_bundle_special_ids?.discount ?? []),
      ...(product?.applicable_bundle_special_ids?.qualify ?? []),
    ]),
  ];
};
